<template>
    <n-list value="categories" text="商品分類" :fields="fields" :items="categories" />
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: '名稱',
                    sortable: true,
                },
                {
                    key: 'products',
                    label: '商品',
                    formatter: value => {
                        return `${value.length}項`
                    },
                    sortable: true,
                },
            ]
        }
    },

    created() {
        this.$store.dispatch('bindCollectionByMerchant', { col: 'categories', merchantId: localStorage.merchantId })
    },

    computed: {
        ...mapState({
            categories: state => state.categories,
        })
    }
}
</script>